<template>
  <section>
    <v-btn
      @click="expiryToggle = true"
      width="100%"
      large
      outlined
      color="primary"
      ><v-icon small class="mx-3">mdi-clock</v-icon>Extend Order Expiry</v-btn
    >
    <v-dialog v-model="expiryToggle" max-width="700px">
      <v-card>
        <v-card-title>
          <h3><strong>Expiry Time Order</strong></h3>
        </v-card-title>
        <v-card-text>
          <v-alert
            v-if="modalServerErrors !== null"
            dense
            outlined
            type="error"
          >
            <p
              class="mb-0"
              v-for="globalErr in modalServerErrors"
              :key="globalErr"
            >
              {{ globalErr[0] }}
            </p>
          </v-alert>
          <formWrapper :validator="$v.expiry_form">
            <form class="form-box" @submit.prevent="saveExpiryTime">
              <v-row>
                <v-col class="py-2" sm="6" cols="12">
                  <form-group name="order_id" :attribute="`fields.order_id`">
                    <template slot-scope="{ attrs, listeners }">
                      <v-text-field
                        v-bind="attrs"
                        v-on="listeners"
                        regular
                        v-model.trim="expiry_form.order_id"
                        type="number"
                      >
                      </v-text-field>
                    </template>
                  </form-group>
                </v-col>
                <v-col class="py-2" sm="6" cols="12">
                  <form-group name="hrs" :attribute="`fields.hrs`">
                    <template slot-scope="{ attrs, listeners }">
                      <v-text-field
                        v-bind="attrs"
                        v-on="listeners"
                        regular
                        v-model.trim="expiry_form.hrs"
                        type="number"
                      >
                      </v-text-field>
                    </template>
                  </form-group>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-btn
                    color="success"
                    :disabled="$v.expiry_form.$invalid"
                    rounded
                    large
                    type="submit"
                    >{{ $t("button.save") }}</v-btn
                  >
                  <v-btn text large @click="expiryToggle = false">Cancel</v-btn>
                </v-col>
              </v-row>
            </form>
          </formWrapper>
        </v-card-text>
      </v-card>
    </v-dialog>
  </section>
</template>

<script>
import { StoreData } from "@/helpers/apiMethods";
import { required, decimal } from "vuelidate/lib/validators";

export default {
  data() {
    return {
      expiry_form: {
        order_id: "",
        hrs: ""
      },
      expiryToggle: false,
      modalServerErrors: null
    };
  },
  methods: {
    saveExpiryTime() {
      const formData = new FormData();
      Object.keys(this.expiry_form).forEach(formItem => {
        formData.append(formItem, this.expiry_form[formItem]);
      });
      StoreData({
        reqName: `orders/extend-expiry`,
        data: formData
      })
        .then(() => {
          this.expiryToggle = false;
          this.reset();
        })
        .catch(err => {
          this.modalServerErrors = err.response.data.errors;
        })
        .finally(() => {});
    },
    reset() {
      this.$v.expiry_form.$reset();
      this.expiry_form = {
        order_id: "",
        hrs: ""
      };
    }
  },
  validations: {
    expiry_form: {
      order_id: {
        required,
        decimal
      },
      hrs: {
        required,
        decimal
      }
    }
  }
};
</script>
